// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../formatDuration/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var formatDurationWithOptions = convertToFP(fn, 2);
export default formatDurationWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/formatDurationWithOptions/index.js
// module id = 876
// module chunks = 0